import { useDispatch } from 'react-redux';
import { Dispatch } from 'redux';

import { TReduxActions } from 'shared/types/redux';

export function useReduxDispatch(): Dispatch<TReduxActions> {
  return useDispatch<Dispatch<TReduxActions>>();
}
